export const APP_STORE_URL =
    'https://apps.apple.com/ro/app/solt-eats-places-foodies/id6450785241';
